// Force reflow to restart element animation/transition.
const reflow = element => {
  element.offsetHeight;
};

export { reflow };
